module.exports = __webpack_public_path__ + "fonts/IBMPlexSans-SemiBold.27319650.eot";